export default __webpack_public_path__ + "bbe4f1679a221d313ddb0565f1e68585.png";